<template>
  <div class="layout--signin">
    <v-container>
      <v-card>
        <v-col class="logo">
          <img src="@/assets/logo/disavowl--white.svg" alt />
        </v-col>
        <v-col>
          <router-view></router-view>
        </v-col>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.layout--signin {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-card {
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
  min-height: 400px;
  max-width: 480px;
  margin: 0 auto;
}
.col {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.logo {
  border-radius: 0 !important;
  background-color: #3e2723;
  img {
    width: 75%;
    max-width: 240px;
  }
}
</style>
